import React from 'react';
import { countryCodeOption } from '../../constants/countryConst';

const RecipientForm = ({ recipientDetails, onChangeRecipient, onChangeCheckbox }) => {
  const {email,
  emailError,
  phoneNumber,
  phoneNumberError,
  ageCheck,
  ageCheckError,
  nameError,
  name,
  country_code,
  customMessage
} = recipientDetails;
  return(
    <div className="form-container" id="recipient-form">
      <p className="preview">Recipient Details</p>
      <div className="gc-box">
        <div className="form-group">
          <label htmlFor="name" className="mini-label">
            Full Name
          </label>
          <div className="form-group">
            <input
              type="name"
              className="form-control"
              id="name"
              name="name"
              value={name}
              onChange={onChangeRecipient}
              placeholder="Full Name"
            />
            <div className="error-msg text-left">{nameError}</div>
          </div>
        </div>
        <div className="form-group  relative ">
          <label htmlFor="phone" className="mini-label">
            Phone
          </label>
          <div className="field-container">
            <select
              disabled={false}
              className="form-control country-code"
              value={country_code}
              name="country_code"
              onChange={onChangeRecipient}
              id="country_code"
            >
              {countryCodeOption.map(option => (
                <option key={option.name} value={option.code}>{`${option.name} +${option.code}`}</option>
              ))}
            </select>
            <input
              type="tel"
              maxLength="10"
              className="form-control"
              id="phoneNumber"
              name="phoneNumber"
              value={phoneNumber}
              onChange={onChangeRecipient}
              placeholder="Phone"
            />
          </div>
          <div className="error-msg text-left">{phoneNumberError ? 'Please enter a valid phone number' : ''}</div>
        </div>
        <div className="form-group ">
          <label htmlFor="email" className="mini-label">
            Email
          </label>
          <div className="form-group">
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={email}
              onChange={onChangeRecipient}
              placeholder="Email"
            />
            <div className="error-msg text-left">
              {emailError}
              {' '}
              {emailError ? 'ID' : ''}
            </div>
          </div>
        </div>
        <div className="form-group ">
          <label htmlFor="customMessage" className="mini-label">
            Custom Message
          </label>
          <textarea
            className="form-control notes"
            placeholder="Custom Message"
            value={customMessage}
            name="customMessage"
            onChange={onChangeRecipient}
            rows="3"
            maxLength="400"
          />
        </div>
        <div className="form-group ">
          <div className="custom-checkbox one-rem-mt ">
            <input type="checkbox" checked={ageCheck} id="ageCheck" name="ageCheck" onChange={onChangeCheckbox} />
            <label className="align-top m-0 text-left" htmlFor="ageCheck">
              <span className="inner normal-font">I confirm that the recipent is above 21 years of age</span>
            </label>
            <div className="error-msg text-left">
              {ageCheckError ? 'Please accept that the recipent is above 21 years of age' : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};


export default RecipientForm;